import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Logo } from "./Logo";
import { useAuth } from "@/lib/auth";
import {
  LayoutDashboard, FileText, ClipboardList, Package, Layers, MessageSquare,
  File, Home, LogOut,
} from "lucide-react";

const LINKS = [
  { to: "/portal", label: "Painel", icon: LayoutDashboard, exact: true, testid: "portal-nav-dashboard" },
  { to: "/portal/orcamentos", label: "Orçamentos", icon: FileText, testid: "portal-nav-quotes" },
  { to: "/portal/propostas", label: "Propostas", icon: ClipboardList, testid: "portal-nav-proposals" },
  { to: "/portal/projetos", label: "Projetos", icon: Layers, testid: "portal-nav-projects" },
  { to: "/portal/encomendas", label: "Encomendas", icon: Package, testid: "portal-nav-orders" },
  { to: "/portal/ficheiros", label: "Ficheiros", icon: File, testid: "portal-nav-files" },
];

export default function ClientLayout({ children }) {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex bg-background">
      <aside className="hidden lg:flex flex-col w-64 border-r border-border bg-card">
        <div className="p-5 border-b border-border">
          <Logo size={64} />
          <p className="tech-label mt-3">Área do cliente</p>
        </div>
        <nav className="p-3 flex-1">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.exact}
              data-testid={l.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded text-sm mb-0.5 ${
                  isActive ? "bg-brand text-white" : "text-foreground/80 hover:bg-secondary"
                }`
              }
            >
              <l.icon size={16} />
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-border">
          <div className="text-sm font-medium truncate">{user?.name}</div>
          <div className="text-xs text-muted-foreground truncate">{user?.email}</div>
          <div className="mt-3 flex items-center gap-3">
            <Link to="/" className="text-xs flex items-center gap-1 text-muted-foreground" data-testid="portal-nav-public">
              <Home size={12} /> Site
            </Link>
            <button onClick={logout} className="text-xs flex items-center gap-1 text-muted-foreground" data-testid="portal-nav-logout">
              <LogOut size={12} /> Sair
            </button>
          </div>
        </div>
      </aside>
      <div className="flex-1 min-w-0">
        <header className="border-b border-border bg-card/60 backdrop-blur px-4 h-14 flex items-center justify-between lg:hidden">
          <Logo size={18} />
          <button onClick={logout} className="text-xs">Sair</button>
        </header>
        <div className="p-6 lg:p-8">{children}</div>
      </div>
    </div>
  );
}
